import { useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { LanguageContext } from "../../../../context/LanguageContext";
import styles from "./ReportsSidebar.module.css";

const ReportsSidebar = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [I18n] = useContext(LanguageContext);

  const REPORT_ROUTES = [
    { path: "/Reports/SaleSummary", label: I18n.sales_summary },
    { path: "/Reports/SalesByPaymentMethod", label: I18n.sales_by_payment_method },
    { path: "/Reports/TotalSalesByChannel", label: I18n.total_sales_by_channel },
    { path: "/Reports/TopSellingItems", label: I18n.top_selling_items },
    { path: "/Reports/LowSellingItems", label: I18n.low_selling_items },
    { path: "/Reports/ProfitMargins", label: I18n.profit_margin },
    { path: "/Reports/SalesByCategory", label: I18n.sales_by_category },
    { path: "/Reports/ExpenseByCategory", label: I18n.expense_by_category },
    { path: "/Reports/TopContactsBySale", label: I18n.top_contacts_by_sale },
    { path: "/Reports/DiscountSummary", label: I18n.discount_summary },
    { path: "/Reports/TaxSummary", label: I18n.tax_summary },
  ];

  return (
    <div className={styles.sidebar}>
      <ul className={styles.navList}>
        {REPORT_ROUTES.map(({ path, label }) => (
          <li key={path}>
            <button
              type="button"
              className={`${styles.navItem} ${pathname === path ? styles.navItemActive : ""}`}
              onClick={() => navigate(path)}
            >
              {label}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ReportsSidebar;
